import { render, staticRenderFns } from "./block-pagination.vue?vue&type=template&id=8391d35e&scoped=true&"
import script from "./block-pagination.vue?vue&type=script&lang=js&"
export * from "./block-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8391d35e",
  null
  
)

export default component.exports